<div class="config-page-container" style="padding: 15px">
  <div class="gt-top-button-row-containers">
    <div class="gt-top-button-gray" *ngFor="let tab of tabs">
      <dx-button
        class="top-button-gray"
        [width]="maxTabLength +  'ch'"
        [text]="tab.text"
        routerLink="{{tab.routerLink}}"
        routerLinkActive="contacts-nav-active"
      ></dx-button>
    </div>
  </div>
  <router-outlet> </router-outlet>
</div>
